import axios from 'axios'
import React, { useEffect, useState } from 'react'

const api = axios.create({
  baseURL: 'https://prod-api.direcaoconcursos.com.br',
})

const Login: React.FC = () => {
  const [testGet, setGetTest] = useState({})
  const [testFetchPost, setFetchPostTest] = useState({})
  const [testAxiosPost, setAxiosPostTest] = useState({})

  useEffect(() => {
    const get = async () => {
      try {
        const fetch_based = await fetch('https://prod-api.direcaoconcursos.com.br?test=proxy')
        const text = await fetch_based.text()

        const axios_based = await api.get('/?test=proxy')

        setGetTest({
          fetch: {
            text,
            status: fetch_based.status,
            statusText: fetch_based.statusText,
          },
          axios: {
            text: axios_based.data,
            status: axios_based.status,
            statusText: axios_based.statusText,
          },
        })
      } catch (error) {
        setGetTest({
          error: error?.message,
          stack: error?.stack,
        })
      }
    }
    // get()

    const post = async () => {
      try {
        const fetch_based = await fetch(
          'https://prod-api.direcaoconcursos.com.br/learning/student/auth?test=proxy',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              email: 'teste@teste.com.br',
              password: '1234',
              platform: 'areaAluno',
            }),
          }
        )
        const json = await fetch_based.json()

        setFetchPostTest({
          fetch: {
            json,
            status: fetch_based.status,
          },
        })
      } catch (error) {
        console.log(error)
        setFetchPostTest({
          fetch: {
            error: error?.message,
            stack: error?.stack,
          },
        })
      }

      try {
        const axios_based = await api.post(
          '/learning/student/auth',
          {
            email: 'teste@teste.com.br',
            password: '1234',
            platform: 'areaAluno',
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )

        setAxiosPostTest({
          axios: {
            text: axios_based.data,
            status: axios_based.status,
            statusText: axios_based.statusText,
          },
        })
      } catch (error) {
        console.log(error)
        setAxiosPostTest({
          axios: {
            error: error?.message,
            stack: error?.stack,
          },
        })
      }
    }
    post()
  }, [])

  return (
    <>
      {/* <pre
        style={{
          padding: '3rem',
          margin: '3rem',
          backgroundColor: '#ddd',
          display: 'block',
          width: 'fit-content',
          color: '#333',
          fontWeight: 600,
          borderRadius: '.5rem',
          whiteSpace: 'pre-wrap',
        }}
      >
        {JSON.stringify(testGet, null, 2)}
      </pre> */}
      <pre
        style={{
          padding: '3rem',
          margin: '3rem',
          backgroundColor: '#ddd',
          display: 'block',
          width: 'fit-content',
          color: '#333',
          fontWeight: 600,
          borderRadius: '.5rem',
          whiteSpace: 'pre-wrap',
        }}
      >
        {JSON.stringify({ ...testFetchPost, ...testAxiosPost }, null, 2)}
      </pre>
    </>
  )
}

export default Login
